<script setup>

import GuestLayout from "@/Layouts/GuestLayout.vue";
import {Link} from  "@inertiajs/vue3";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
</script>

<template>
    <GuestLayout>
        <div class="px-2 pt-4">
            <div class="mb-20 mini:mb-8 sm:md:mb-8">
                <Link href="/" class="flex flex-col mini:flex-row sm:md:flex-row items-center justify-start mini:justify-center h-10">
                    <div class="mb-2 mini:mr-4 sm:md:mr-4 mini:mb-0 sm:md:mb-0">
                        <ApplicationLogo class="fill-current text-gray-500 h-12" />
                    </div>
                    <div class="flex flex-col justify-center">
                        <div class="text-xl sm:text-md mt-1 uppercase whitespace-nowrap leading-5 sm:leading-2 ">Личный кабинет</div>
                        <div class="tracking-wide tracking-wider">студента и сотрудника</div>
                    </div>
                </Link>
            </div>

            <slot/>

            <div class="mt-4 flex justify-center">
                <span>Техническая поддержка - <a href="mailto:lk@nngasu.ru" class="text-blue-600 hover:text-blue-900">lk@nngasu.ru</a> </span>
            </div>
        </div>
    </GuestLayout>
</template>


